<template>
  <error-dialog :value="flag" :props="{ persistent: true, 'max-width': '50%' }" @ok-button-click="onClickOk">
    <template v-slot:content>
      {{ message }}
    </template>
  </error-dialog>
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import ErrorDialog from '@/components/dialog/ErrorDialog.vue';
import Store from '@/store';
import { undoError } from '@/libs/store/error';

const UNEXPECTED_ERROR_MESSAGE = 'サーバーエラーが発生しました。';

const props = Vue.extend({
  props: {
    messages: { type: Object, default: {} },
  },
});

@Component({ components: { ErrorDialog } })
export default class ErrorMessageDialog extends props {
  get flag(): boolean {
    return Store.getters.error.flag;
  }

  get msg(): string {
    return Store.getters.error.msg;
  }

  get message(): string {
    if (this.flag) {
      const msg = this.msg;
      return this.messages[msg] || UNEXPECTED_ERROR_MESSAGE;
    }
    return '';
  }

  private onClickOk() {
    undoError();
  }
}
</script>
